import { Pipe, PipeTransform } from '@angular/core';
import { blank, filled, OptionalValue } from '../shared/utils/common';
import { lowerCase } from 'lodash-es';

@Pipe({
  name: 'str_compare',
  pure: false,
})
export class StrComparePipe implements PipeTransform {
  transform(value: OptionalValue<string>, other: OptionalValue<string>, opts: {
    strict?: boolean;
  } = {}) {
    opts = Object.assign({
      strict: false,
    }, opts);

    if (filled(value) && blank(other)) {
      return false;
    }

    if (opts.strict) {
      return value === other;
    }

    value = lowerCase(value);
    other = lowerCase(other);

    return value === other;
  }
}